<div class="page">
  <div class="title-btn-container">
    <div class="title">{{ 'store.categories.title' | translate }}</div>
  </div>
  <div class="vouchers-filters-container">
    <div class="inputs-container">
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input [(ngModel)]="params.search" (keyup.enter)="doSearchByEnter($event);" (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.categories.searchPlaceholder' | translate" type="text">
      </div>
      <div class="title-btn-container" style=" justify-content: flex-end;">
        <div class="btns-container">
          <button (click)="createNewCategory(-1)" data-bs-toggle="modal" data-bs-target="#categoryModal">
            <img src="assets/images/add-btn.png" alt="">
            {{ 'store.categories.create' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="table-wrapper">
    <table class="table AgentsTable">
      <thead>
        <tr>
          <th>{{ 'store.categories.table.name' | translate }}</th>
          <th>{{ 'store.categories.table.nameAr' | translate }}</th>
          <th>{{ 'store.products.table.createdDate' | translate }}</th>
          <th>{{ 'store.products.table.updatedDate' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataList; let i = index">
          <td>
            {{item.name}}
          </td>
          <td>{{item.nameAr}}</td>
          <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></td>
          <td ><span class="ltr-text">{{item.updatedDate | date: 'hh:mm, d MMMM y' }}</span></td>

          <td class="dots-container">
            <button [placement]="'left'" [outsideClick]="true" #pop="bs-popover" [popover]="popTemplate">
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </button>

            <ng-template #popTemplate>
              <div style="cursor: pointer;border-bottom: 0.5px solid #dee3e7;padding: 10px;" data-bs-toggle="modal"
                data-bs-target="#categoryModal" (click)="goToDetails(item)">
                {{ 'store.categories.edit' | translate }}
              </div>
              <div style="cursor: pointer; padding: 10px" (click)="openConfirmDialog(item)" data-bs-toggle="modal"
                data-bs-target="#confirmModal"> {{ 'store.categories.delete' | translate }}
              </div>
            </ng-template>
          </td>
        </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.categories.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
      (nextClicked)="nextClick($event)"></app-pagination>
    <!-- <app-export-csv [disabled]="!dataList?.length" path="web/vouchers/csv" [params]="params"></app-export-csv> -->
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>

<app-confirm-dialog [itemName]="selectedItemName" (onConfirm)="deleteItem()"></app-confirm-dialog>

<app-category-modal [title]="modalTitle" [category]="selectedCategory"
  (onSave)="saveCategory($event)"></app-category-modal>
